import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

export interface InviteListItem {
  id: string;
  email: string;
  status: string;
  expiresAt: string;
  createdAt: string;
}

export interface CreateInviteRequest {
  email: string;
  position?: string | null;
  roleId?: string | null;
  systemRole?: number | null;
  ttlDays?: number | null;
}

export interface BulkInviteRequest {
  users: CreateInviteRequest[];
}

@Injectable({ providedIn: 'root' })
export class InviteService {
  private readonly api = inject(ApiService);

  list(email?: string): Observable<InviteListItem[]> {
    // This functionality is now handled by UsersController getUsers
    return this.api.get<InviteListItem[]>('/users', { params: email ? { email } : undefined, skipToast: true });
  }

  create(req: CreateInviteRequest): Observable<InviteListItem> {
    // This functionality is now handled by UsersController createUser
    return this.api.post<InviteListItem>('/users', req, { skipToast: true });
  }

  bulk(req: BulkInviteRequest): Observable<InviteListItem[]> {
    // This functionality is now handled by UsersController bulk
    return this.api.post<InviteListItem[]>('/users/bulk', req, { skipToast: true });
  }

  resend(id: string): Observable<InviteListItem> {
    // This functionality is now handled by UsersController resend
    return this.api.post<InviteListItem>(`/users/${id}/resend`, {}, { skipToast: true });
  }

  cancel(id: string): Observable<void> {
    // This functionality is now handled by UsersController cancel
    return this.api.delete<void>(`/users/${id}/cancel`, { skipToast: true });
  }
}
